// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_690","cls2":"LoswpTabsHero-cls2_WE3 LoswpTabsHero-cls1_690"};